import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="error-boundary bg-red-50 border border-red-200 rounded-lg p-6 m-4">
          <div className="flex items-center mb-4">
            <span className="text-red-500 text-xl mr-2">⚠️</span>
            <h2 className="text-lg font-semibold text-red-700">
              Oops! Ceva nu a funcționat corect
            </h2>
          </div>
          
          <p className="text-red-600 mb-4">
            A apărut o eroare neașteptată. Vă rugăm să reîncărcați pagina sau să contactați suportul.
          </p>
          
          <div className="flex gap-2">
            <button
              onClick={() => window.location.reload()}
              className="bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700"
            >
              🔄 Reîncarcă Pagina
            </button>
            
            <button
              onClick={() => this.setState({ hasError: false, error: null, errorInfo: null })}
              className="bg-gray-600 text-white px-4 py-2 rounded hover:bg-gray-700"
            >
              🔙 Încearcă Din Nou
            </button>
          </div>
          
          {this.props.showDetails && (
            <details className="mt-4">
              <summary className="cursor-pointer text-red-600 font-medium">
                Detalii Tehnice (pentru dezvoltatori)
              </summary>
              <pre className="mt-2 p-2 bg-red-100 rounded text-xs overflow-auto">
                {this.state.error && this.state.error.toString()}
                <br />
                {this.state.errorInfo.componentStack}
              </pre>
            </details>
          )}
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary; 
 